import React, { useState } from 'react';
import {
  Grid,
  TextField,
  Button,
  RadioGroup,
  Radio,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Checkbox,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import { LinkStyled } from './LoginForm.styled';
import { Link } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';

export const RegisterForm = ({
  formData,
  handleChange,
  handleSubmit,
  isRegistering,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [parentConsent, setParentConsent] = useState(false);
  const [termsConsent, setTermsConsent] = useState(false);

   const isStudent = formData.role === 'student'; 
  
  const handleClickShowPassword = () => setShowPassword((prev) => !prev);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

   const isFormValid = () => {
    const { name, lastName, email, password } = formData;
    const isAllFieldsFilled = name && lastName && email && password;
    return isAllFieldsFilled && termsConsent && (!isStudent || parentConsent);
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="center">
            <RadioGroup
              name="role"
              value={formData.role}
              onChange={handleChange}
              row
            >
              <FormControlLabel
                value="teacher"
                control={<Radio />}
                label="Insegnante"
              />
              <FormControlLabel
                value="student"
                control={<Radio />}
                label="Alunno"
              />
            </RadioGroup>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Nome"
            variant="outlined"
            fullWidth
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Cognome"
            variant="outlined"
            fullWidth
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Email"
            type="email"
            variant="outlined"
            fullWidth
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            label="Password"
            type={showPassword ? 'text' : 'password'}
            variant="outlined"
            fullWidth
            name="password"
            value={formData.password}
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
 {/* Checkbox for parental consent */}
        {isStudent && 
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={parentConsent}
                onChange={(e) => setParentConsent(e.target.checked)}

              />
            }
            label={
              <Typography variant="body2" style={{ fontSize: '12px', textAlign: 'left' }}>
                Confermo che il mio genitore/tutore ha letto e approvato la mia registrazione a mathlab.it e l'uso dei miei dati personali secondo la Normativa sulla privacy.
              </Typography>}
          />
        </Grid>
        }
        {/* Checkbox for terms and privacy policy */}
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={termsConsent}
                onChange={(e) => setTermsConsent(e.target.checked)}
              />
            }
            label={
              <Typography variant="body2" style={{ fontSize: '12px', textAlign: 'left' }}>
                Sì, accetto le <Link to="/general-conditions" style={{ textDecoration: 'none', color: '#0000EE', display:'inline' }}>Condizioni di utilizzo</Link>, l'uso dei cookie e acconsento al trattamento dei miei dati personali in conformità con la Normativa sulla privacy.
              </Typography>
            }
          />
        </Grid>
        <Grid item xs={12}>
          <Box mt={2} textAlign="left">
            <Typography variant="body2" style={{ fontSize: '12px' }}>
              Riceverai aggiornamenti e novità occasionalmente via email, con la possibilità di annullare l'iscrizione in qualsiasi momento tramite il link presente in ogni messaggio.
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isRegistering || !isFormValid()}
          >
            Registrati
          </Button>
        </Grid>
        <Grid item xs={12}>
          <LinkStyled component={Link} to="/login">
            Sei già resgistrato? Accedi
          </LinkStyled>
        </Grid>        
      </Grid>
    </form>
  );
};